
import PredefinedCustomerSelect from "@components/predefined-customer-select/predefined-customer-select";
import MultipleOrganizationAutoComplete from "@components/multiple-organization-auto-complete/multiple-organization-auto-complete";
import PredefinedTableLayout from "@components/predefined-table-layout/predefined-table-layout";
import ItemAutoComplete from "@components/itemspec-auto-complete/itemspec-auto-complete";
import PredefinedExportBtn from "@components/predefined-export-btn/predefined-export-btn";
import ReceiptAutoComplete from "@components/receipt-auto-complete/receipt-auto-complete";
import SimplifiedPager from "@components/simplified-pager/simplified-pager";
import CustomizeTable from "@components/customize-table/customize-table";
import FacilitySelect from "@components/facility-select/facility-select";
import ElementSelect from "@components/element-select/element-select";
import WaittingBtn from "@components/waitting-button/waitting-btn";
import DateRange from "@components/date-range/date-range";
import TagsInput from "@components/tags-input/tags-input";
import errorHandler from "@shared/error-handler";
import Pager from "@components/pager/pager";
import CustomerWiseVue from "@shared/customer-wise-vue";
import { Component, Watch } from "vue-property-decorator";
import util from "@shared/util";
import { cloneDeep, remove, forEach, groupBy, find, filter, keyBy, concat, indexOf, isEmpty, includes, map, sumBy, sum } from "lodash-es";
import outboundService from "@services/outbound-service";
import fileService from "@services/file-service";
import organizationService from "@services/organization-service";
import { Subject, Observable } from "rxjs";
import "rxjs/add/operator/debounceTime";
import tlp from "./inquiry.vue";
import reportUtil from "@shared/report-util";
import PopUpWindows from "@components/pop-up-windows/pop-up-windows";
import TableDragDrop from "@components/table-drag-drop/table-drag-drop";
import { finalize } from "rxjs/operators";

enum PdfFileType {
    PDF = 'pdf',
    M_BOL = 'mBol',
    PACKING_LIST = 'packingListPdf',
    G_PACKING_LIST = 'genericPackingListPdf',
}

@Component({
    mixins: [tlp],
    components: {
        PredefinedCustomerSelect,
        PredefinedTableLayout,
        PredefinedExportBtn,
        ElementSelect,
        ReceiptAutoComplete,
        FacilitySelect,
        DateRange,
        CustomizeTable,
        Pager,
        TagsInput,
        WaittingBtn,
        SimplifiedPager,
        ItemAutoComplete,
        MultipleOrganizationAutoComplete,
        PopUpWindows,
        TableDragDrop
    }
})
export default class OutboundInqury extends CustomerWiseVue {

    searchParam: any = {
        paging: {pageNo: 1, limit: 10},
        reportCategory: 'OUTBOUND_INQUIRY',
        loadStatuses: []
    };
    inquiryReports: any = {};
    statues: Array<any> = ['Imported', 'Open', 'Committed', 'Partial Committed', 'Commit Blocked', 'Commit Failed', 'Pending', 'On Hold', 'Planning', 'Planned', 'Picking', 'Picked', 'Packing', 'Packed', 'Staged', 'Loading', 'Loaded', 'Partial Shipped', 'Short Shipped', 'Shipped', 'Closed', 'Cancelled', 'Reopen', 'Exception'];
    loadStatues: Array<any> = ['New', 'Window Checkin Done', 'Loading', 'Loaded', 'Shipped', 'Cancelled'];
    facilities: Array<any> = [];
    searchResultPaging: any = {};
    modeType: string = "";
    loading = false;
    customizeComplete = false;
    customerIds: Array<string> = [];
    exportLoading: boolean = false;
    searchByInput: Subject<void> = new Subject();
    itemSNDetails: any = {};
    ItemShowSNDetais: any = {};
    ItemSNDetailoading: any = {};
    exportDates: Array<any> = ['Expanding Level(.xls)'];
    itemExcelLoadingObj: any = {};
    excelByFacilityAll: any = {};
    attachmentOrder: any = {};
    customizitionTableView: any = {};
    cancelNote: String = '';
    orderId: String = '';
    sortingField: any = {};
    popUpConfig: any = {
        isShow: false,
        submitFunc: () => {},
        height: 0,
        title: '',
        isSubmit: false,
        cancelFunc: function() {
            this.isShow = false;
        },
        modal: ''
    };
    allowReturnLabel: boolean = false;
    showReturnLabel: boolean = false;
    shipmentDetails: any = [];

    PdfFileType = PdfFileType;
    pdfsDownloadStatus = new Map<string, Map<string, boolean>>();

    @Watch('inquiryReports.data')
    watchInquiryReportsDataChange() {
        // when the data source has changed, the old status are useless, clear
        this.pdfsDownloadStatus.clear();
    }

    onSelectExportName(payload: any) {
        this.exportLoading = true;
        if (this.searchParam.facility.name == "All") {
            let param = this.getParamWithFillRelatedTitleIds(cloneDeep(this.searchParam));
            this.deleteParams(param);
            param.headerList = reportUtil.getExcelColumnList(this.customizitionTableView);
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "id");
            let facilityIds = param.facility.id.split(",");
            param.facilityName = "valleyview";
            param.facilityIds = facilityIds;
            if (indexOf(param.headerList, "Facility") == -1) {
                param.headerList.unshift("Facility");
            }
            param = this.addOrderIds(param);
            outboundService.multipleFacilityDownload(param).then(res => {
                this.exportLoading = false;
                util.exportFile(res, "Outbound-Inquiry-Expanding.xlsx");
            }, err => {
                this.exportLoading = false;
                errorHandler.handle(err);
            });
        }
        else {
        this.exportExcel(payload).then((res => {
            this.exportLoading = false;
            if (payload === 'Order Level (.xls)') {
                util.exportFile(res, "Outbound-Inquiry-Order-Level.xlsx");
            }
            else if (payload === 'Item Level (.xls)') {
                util.exportFile(res, "Outbound-Inquiry-Item-Level.xlsx");
            }
            else if (payload === 'ID Level (.xls)') {
                util.exportFile(res, "Outbound-Inquiry-ID-Level.xlsx");
            }
            else if (payload === 'Carton Level (.xls)') {
                util.exportFile(res, "Outbound-Inquiry-Carton-Level.xlsx");
            }
            else if (payload === 'Expanding Level(.xls)') {
                util.exportFile(res, "Outbound-Inquiry-Expanding.xlsx");
            }
        })).catch(err => {
            this.exportLoading = false;
            errorHandler.handle(err);
        });
    }
    }

    addOrderIds(params: any) {
        if (this.selectedInquirys.length) {
            params.orderIds = [];
            forEach(this.selectedInquirys, (item) => {
                params.orderIds.push(item.orderId);
            });
        }
        return params;
    }

    onSelectCreateDateRange(payload: any) {
        this.searchParam.createdWhenFrom = payload.timeFrom;
        this.searchParam.createdWhenTo = payload.timeTo;
        // this.searchReport();
    }

    onSelectAppointmentDateRange(payload: any) {
        this.searchParam.appointmentTimeFrom = payload.timeFrom;
        this.searchParam.appointmentTimeTo = payload.timeTo;
        // this.searchReport();
    }

    onSelectMabdDateRange(payload: any) {
        this.searchParam.mabdFrom = payload.timeFrom;
        this.searchParam.mabdTo = payload.timeTo;
        // this.searchReport();
    }

    onSelectLoadCompleteDateRange(payload: any) {
        this.searchParam.shippedTimeFrom = payload.timeFrom;
        this.searchParam.shippedTimeTo = payload.timeTo;
        // this.searchReport();
    }

    onSelectStatus(payload: any) {
        // this.searchReport();
    }

    onSelectCustomizeTable(payload: any) {
        this.customizitionTableView = payload;
        let querys = this.$route.query;
        if (querys) {
            if (querys.orderIds) {
                this.searchParam.orderIds = querys.orderIds;
                if (typeof querys.orderIds === 'string') {
                    this.searchParam.orderIds = [querys.orderIds];
                }
            }
            if (querys.itemSpecId) {
                this.searchParam.itemSpecIds = [querys.itemSpecId];
                this.searchParam.itemSpecId = querys.itemSpecId;
            }
            if (querys.titleId) {
                this.searchParam.titleIds = [querys.titleId];
            }
            this.searchReport();
        } else {
            if (!this.customizitionTableView.isFirstInit) {
                this.searchReport();
            }
        }
        this.customizeComplete = true;

    }

    onSelectFacilityChange(payload: any) {
        // this.searchReport();
    }

    isSelectItem: boolean = false;
    onselectCustomerChange(payload: any) {
        // this.searchReport();
        this.searchParam.titleIds = [];
        this.searchParam.itemSpecId = null;
        this.isSelectItem = true;
        this.customizeComplete = false;
        this.getCustomerSetting(payload.id);
    }

    getCustomerSetting(customerId: any) {
        this.allowReturnLabel = false;
        organizationService.getCustomerByOrgId(customerId)
            .subscribe(
                (res: any) => {
                    if (!isEmpty(res.returnDeliveryServices)) {
                        this.allowReturnLabel = true;
                    } else {
                        this.allowReturnLabel = false;
                    }
                },
                (err: any) => {
                    this.error(err);
                }
            );
    }

    currentOrderInquiry: any = {};
    showReturnLabeling: boolean = false;

    showPopReturnLabel(orderId: any, trackingNo: any, orderInquiry: any) {
        if (!trackingNo) {
            return;
        }
        this.showReturnLabel = true;
        this.shipmentDetails = [];
        this.currentOrderInquiry = orderInquiry;
        this.showReturnLabeling = true;
        outboundService.searchSmallParcelShipmentDetail({ orderIds: [orderId], excludeSmallParcelLabelTypes: null })
            .subscribe(
                (res: any) => {
                    this.shipmentDetails = filter(res, (shipmentDetail) => {
                        const trackingNoArray = shipmentDetail.trackingNo.split(',');
                        return shipmentDetail.orderId == orderId && trackingNoArray.includes(trackingNo);
                    });
                    forEach(this.shipmentDetails, shipmentDetail => {
                        shipmentDetail.inputQty = shipmentDetail.qty;
                    });
                    this.showReturnLabeling = false;
                },
                (err: any) => {
                    this.showReturnLabeling = false;
                    this.error(err);
                }
            );
    }

    createReturnLabeling: boolean = false;

    createReturnLabel() {
        let createShipmentDetails = filter(this.shipmentDetails, (shipmentDetail: any) => {
            return includes(this.selectedReturnLabels, shipmentDetail.itemSpecName);
        });
        let itemList: any = [];
        forEach(createShipmentDetails, (createShipmentDetail: any) => {
            itemList.push({
                itemSpecId: createShipmentDetail.itemSpecId,
                orderId: createShipmentDetail.orderId,
                qty: createShipmentDetail.inputQty,
                unitId: createShipmentDetail.unitId,
            });
        });
        let param = {
            "packageType": "CP", "labelType": "ZPL", "packageLength": this.packageInfo.packageLength, "returnLabel": true, "itemList": itemList
            , "packageHeight": this.packageInfo.packageHeight, "packageWidth": this.packageInfo.packageWidth, "packageWeight": this.packageInfo.packageWeight
        };
        this.createReturnLabeling = true;
        outboundService.createReturnLabel(param)
            .subscribe(
                (res: any) => {
                    this.showChildItemTable(this.getItemLevelKey(this.currentOrderInquiry), this.currentOrderInquiry.facilityName, true);
                    this.cancelShowReturnLabel();
                    this.createReturnLabeling = false;
                },
                (err: any) => {
                    this.createReturnLabeling = false;
                    this.error(err);
                }
            );
    }

    downloadReturnLabel(returnTrackingNo: any) {
        fileService.getCombinedPdf(`/bam/outbound/small-parcel-shipment/preview-label/${returnTrackingNo}`, { responseType: 'arraybuffer' }).then((res => {
            this.$forceUpdate();
            util.exportFile(res, `${returnTrackingNo}.pdf`);
        })).catch(err => {
            errorHandler.handle(err);
        });
    }

    getReturnLabels(returnTrackingNoToString: any) {
        if (returnTrackingNoToString) {
            return returnTrackingNoToString.split(",");
        }
        return [];
    }


    selectedReturnLabels: any = [];
    isSelectedAllReturnLabel: boolean = false;
    packageInfo: any = {};

    isCheckedReturnLabel(shipmentDetail: any) {
        if (includes(this.selectedReturnLabels, shipmentDetail.itemSpecName)) {
            return true;
        } else {
            return false;
        }
    }

    selectSingleReturnLabel(shipmentDetail: any) {
        if (this.isCheckedReturnLabel(shipmentDetail)) {
            remove(this.selectedReturnLabels, (selectedReturnLabel: any) => {
                return selectedReturnLabel == shipmentDetail.itemSpecName;
            });
        } else {
            this.selectedReturnLabels.push(shipmentDetail.itemSpecName);
        }
        if (this.selectedReturnLabels.length == this.shipmentDetails.length && this.shipmentDetails.length != 0) {
            this.isSelectedAllReturnLabel = true;
        } else {
            this.isSelectedAllReturnLabel = false;
        }
        this.fillPackageInfo();
    }

    selectAllReturnLabel() {
        if (this.isSelectedAllReturnLabel) {
            this.selectedReturnLabels = [];
            this.isSelectedAllReturnLabel = false;
        } else {
            this.isSelectedAllReturnLabel = true;
            this.selectedReturnLabels = map(this.shipmentDetails, "itemSpecName");
        }
        this.fillPackageInfo();
    }

    fillPackageInfo() {
        let isAllQty = true;
        forEach(this.shipmentDetails, (shipmentDetail: any) => {
            if (shipmentDetail.inputQty != shipmentDetail.qty) {
                isAllQty = false;
            }
        });
        this.packageInfo = {};
        let selectedShipmentDetails = filter(this.shipmentDetails, (shipmentDetail: any) => { return includes(this.selectedReturnLabels, shipmentDetail.itemSpecName); });
        let weight = sum(map(selectedShipmentDetails, (shipmentDetail: any) => {
            return shipmentDetail.inputQty * shipmentDetail.unit.weight;
        }));

        if (this.isSelectedAllReturnLabel && isAllQty && this.shipmentDetails[0]) {
            this.packageInfo.packageLength = this.shipmentDetails[0].packageLength;
            this.packageInfo.packageWidth = this.shipmentDetails[0].packageWidth;
            this.packageInfo.packageHeight = this.shipmentDetails[0].packageHeight;
            this.shipmentDetails[0].packageWeight = this.shipmentDetails[0].packageWeight || 0;
            if (this.shipmentDetails[0].packageTypeItemSpecId) {
                this.packageInfo.packageWeight = this.shipmentDetails[0].packageWeight;
            } else {
                this.packageInfo.packageWeight = weight;
            }
        }
        else if (selectedShipmentDetails.length == 1 && selectedShipmentDetails[0].inputQty == 1) {
            this.packageInfo.packageLength = selectedShipmentDetails[0].unit.length;
            this.packageInfo.packageWidth = selectedShipmentDetails[0].unit.width;
            this.packageInfo.packageHeight = selectedShipmentDetails[0].unit.height;
            this.packageInfo.packageWeight = weight;
        } else {
            this.packageInfo.packageWeight = weight;
        }
        this.packageInfo.packageLength = this.packageInfo.packageLength ? this.packageInfo.packageLength.toFixed(2) : undefined;
        this.packageInfo.packageWidth = this.packageInfo.packageWidth ? this.packageInfo.packageWidth.toFixed(2) : undefined;
        this.packageInfo.packageHeight = this.packageInfo.packageHeight ? this.packageInfo.packageHeight.toFixed(2) : undefined;
        this.packageInfo.packageWeight = this.packageInfo.packageWeight ? this.packageInfo.packageWeight.toFixed(2) : undefined;
    }

    inputQtyBlur() {
        this.fillPackageInfo();
    }

    cancelShowReturnLabel() {
        this.showReturnLabel = false;
        this.shipmentDetails = [];
        this.selectedReturnLabels = [];
        this.packageInfo = {};
        this.isSelectedAllReturnLabel = false;
    }

    selectedLayout: any = null;
    onGroupViewLayoutChange(layout: any) {
        this.selectedLayout = layout;
        if (!layout || !layout.groupColumns || layout.groupColumns.length === 0) {
            this.setInitGroupReport();
        } else {
            this.inquiryReports.data = reportUtil.getReOrgGroupTableSource(this.orginInquiryReports.data, layout);
        }
    }

    tableModeName: string = 'Nested Layout';
    onViewModeChange(viewModeName: any) {
        this.tableModeName = viewModeName;
        this.searchReport();
    }

    dragStart(event: any) {
        event.dataTransfer.setData("Text", event.target.innerText);
    }

    orginInquiryReports: any = [];
    private searchOutboundInquiryOrderLevelReportByPaging() {
        if (!this.searchParam.headerList.length) {
            errorHandler.handle('Please Select at least one criteria for each customize column.');
            return;
        }
        this.inquiryReports = [];
        this.searchResultPaging = [];
        this.initOrderChildItem();
        this.loading = true;
        if (this.searchParam.facility.name == "All") {
            let searchParam = this.getParamWithFillRelatedTitleIds(cloneDeep(this.searchParam));
            this.deleteParams(searchParam);
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "id");
            let facilityIds = searchParam.facility.id.split(",");
            let length = facilityIds.length;
            searchParam.paging.limit = Math.round(1000 / length);
            let promise: Array<any> = [];
            forEach(facilityIds, function (id) {
                searchParam.facilityId = id;
                searchParam.facilityName = facilities[id].accessUrl.toLowerCase();
                let param = cloneDeep(searchParam);
                promise.push(outboundService.searchOutboundInquiryOrderLevelReportByPaging(param).toPromise());
            });
            let orginInquiryReports: any = { data: [] };
            Promise.all(promise).then(res => {
                for (let i = 0; i < res.length; i++) {
                    forEach(res[i].results.data, function (obj) {
                        obj.facilityId = facilityIds[i];
                        obj.facilityName = facilities[facilityIds[i]].name;
                    });
                }
                forEach(res, function (data) {
                    orginInquiryReports.data = concat(orginInquiryReports.data, data.results.data);
                    orginInquiryReports.head = data.results.head;
                });
                this.orginInquiryReports = orginInquiryReports;
                this.inquiryReports = this.addHeadOption(cloneDeep(orginInquiryReports));
                this.excelByFacilityAll = cloneDeep(orginInquiryReports);
                this.isSelectedAll = false;
                this.selectedInquirys = [];

                // facility为All 前端分页
                this.searchResultPaging.totalCount = this.excelByFacilityAll.data.length;
                this.searchParam.paging.limit = 10;
                this.loadContentFacilityAll(1);

                this.loading = false;
            }, err => {
                errorHandler.handle(err);
                this.loading = false;
            });
        } else {
        let searchParam = this.removeFacilityParamAndFillTitleIdsWhenSearch(cloneDeep(this.searchParam));
        this.deleteParams(searchParam);
        outboundService.searchOutboundInquiryOrderLevelReportByPaging(searchParam).subscribe(
            res => {
                this.orginInquiryReports = cloneDeep(res.results);
                this.selectedInquirys = [];
                this.isSelectedAll = false;
                this.inquiryReports = this.addHeadOption(res.results);
                this.searchResultPaging = res.paging;
                this.setInitGroupReport();
                this.loading = false;
            },
            err => {
                this.loading = false;
                errorHandler.handle(err);
            }
        );
    }
    }

    addHeadOption = function (params: Object) {
        for (let[ key, value ] of Object.entries(params)) {
            if ( key === 'head' ) {
                value = Array.prototype.concat.apply(['Action', ''], value );
            }
            Object.assign(params, {[key]: value});
        }
        return params;
    };

    private searchInquiryExpandingReportByPaging() {
        if (!this.searchParam.headerList.length) {
            errorHandler.handle('Please Select at least one criteria for each customize column.');
            return;
        }
        this.inquiryReports = [];
        this.searchResultPaging = [];
        this.initOrderChildItem();
        this.loading = true;
        if (this.searchParam.facility.name == "All") {
            let searchParam = this.getParamWithFillRelatedTitleIds(cloneDeep(this.searchParam));
            this.deleteParams(searchParam);
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "id");
            let facilityIds = searchParam.facility.id.split(",");
            let length = facilityIds.length;
            searchParam.paging.limit = Math.round(1000 / length);
            let promise: Array<any> = [];
            forEach(facilityIds, function (id) {
                searchParam.facilityId = id;
                searchParam.facilityName = facilities[id].accessUrl.toLowerCase();
                let param = cloneDeep(searchParam);
                promise.push(outboundService.searchOutboundInquiryExpandingReportByPaging(param).toPromise());
            });
            let orginInquiryReports: any = { data: [] };
            Promise.all(promise).then(res => {
                for (let i = 0; i < res.length; i++) {
                    forEach(res[i].results.data, function (obj) {
                        obj.facilityId = facilityIds[i];
                        obj.facilityName = facilities[facilityIds[i]].name;
                    });
                }
                forEach(res, function (data) {
                    orginInquiryReports.data = concat(orginInquiryReports.data, data.results.data);
                    orginInquiryReports.head = data.results.head;
                });
                this.orginInquiryReports = orginInquiryReports;
                this.inquiryReports = this.addHeadOption(cloneDeep(orginInquiryReports));
                this.excelByFacilityAll = cloneDeep(orginInquiryReports);
                this.isSelectedAll = false;
                this.selectedInquirys = [];

                // facility为All 前端分页
                this.searchResultPaging.totalCount = this.excelByFacilityAll.data.length;
                this.searchParam.paging.limit = 10;
                this.loadContentFacilityAll(1);

                this.loading = false;
            }, err => {
                errorHandler.handle(err);
                this.loading = false;
            });
        } else {
        let searchParam = this.removeFacilityParamAndFillTitleIdsWhenSearch(cloneDeep(this.searchParam));
        this.deleteParams(searchParam);
        outboundService.searchOutboundInquiryExpandingReportByPaging(searchParam).subscribe(
            res => {
                this.orginInquiryReports = cloneDeep(res.results);
                this.selectedInquirys = [];
                this.isSelectedAll = false;
                this.inquiryReports = this.addHeadOption(res.results);
                this.searchResultPaging = res.paging;
                this.setInitGroupReport();
                this.loading = false;
            },
            err => {
                this.loading = false;
                errorHandler.handle(err);
            }
        );
        }
    }

    private setInitGroupReport() {
        let reports = cloneDeep(this.orginInquiryReports.data);
        forEach(reports, (dt) => {
            dt.source = 'dbSource';
        });
        this.inquiryReports.data = groupBy(reports, 'source');
        // when customize change and has been selected layout
        if (this.selectedLayout && this.selectedLayout.groupColumns.length > 0) {
            this.inquiryReports.data = reportUtil.getReOrgGroupTableSource(this.orginInquiryReports.data, this.selectedLayout);
        }
    }

    statusByTabName: any = {
        // 'All': ['Imported', 'Open', 'Committed', 'Partial Committed', 'Commit Blocked', 'Commit Failed', 'Pending', 'On Hold', 'Planning', 'Planned', 'Picking', 'Picked', 'Packing', 'Packed', 'Staged', 'Loading', 'Loaded', 'Partial Shipped', 'Short Shipped', 'Shipped', 'Closed', 'Cancelled', 'Reopened'],
        'All': [],
        'Open': ['Imported', 'Open'],
        'Scheduled': ['Imported', 'Open', 'Picking', 'Picked', 'Staging'],
        'Daily Shipped': ['Shipped'],
        'MTD Shipped': ['Shipped']

    };

    currentTagName: string = 'All';
    onClickStatuTab(tabName: string) {
        this.searchParam.statuses = this.statusByTabName[tabName];
        if (tabName === this.currentTagName) return;
        this.modeType = '';
        this.selectedLayout = null;
        this.currentTagName = tabName;
        delete this.searchParam.shippedTimeTo;
        delete this.searchParam.shippedTimeFrom;
        this.searchParam.reportCategory = 'OUTBOUND_INQUIRY';
        if (tabName === 'Daily Shipped') {
            this.searchParam.shippedTimeTo = util.fomateEndDate(new Date());
            this.searchParam.shippedTimeFrom = util.fomateStartDate(new Date());
        } else if (tabName === 'MTD Shipped') {
            this.modeType = 'MTD';
            this.searchParam.shippedTimeTo = util.fomateEndDate(new Date());
            this.searchParam.shippedTimeFrom = util.fomateCurrentMMFirstDay(new Date());

        }
        this.searchReport();
    }

    private init() {
        this.customerIds = this.getCustomerIds();
    }

    searchReport() {
        this.searchParam.paging = { pageNo: 1, limit: 10 };
        this.search();
    }

    onselectChange(payload: any) {
        if (!payload) {
            this.searchParam.itemSpecIds = [];
        } else {
            this.searchParam.itemSpecIds = [payload.id];
        }
    }

    private search() {

        if (this.$route.query.statuses && this.currentTagName === "All") {
            this.searchParam.statuses = this.$route.query.statuses;
        }
        if (this.sortingField.sortingFields && this.sortingField.sortingFields.length > 0) {
            this.searchParam.sortingFields = this.sortingField.sortingFields;
            this.searchParam.sortingOrder = this.sortingField.sortingOrder;
        }
        this.searchParam.generalDynFields = reportUtil.getGeneralDynFields(this.customizitionTableView);
        this.searchParam.detailDynFields = reportUtil.getDetailDynFields(this.customizitionTableView);
        if (this.tableModeName === 'Nested Layout') {
            this.searchParam.headerList = reportUtil.getNestedColumnList(this.customizitionTableView);
            this.searchOutboundInquiryOrderLevelReportByPaging();
        } else {
            this.searchParam.headerList = reportUtil.getFlatColumnList(this.customizitionTableView);
            this.searchInquiryExpandingReportByPaging();
        }
    }

    private sortingFields(head: any, sortingOrder: any) {
        this.sortingField[head] = sortingOrder;
        this.sortingField.sortingOrder = sortingOrder;
        if (head == 'Rush') this.sortingField.sortingFields = ["isRush", "createdWhen"];
        else  this.sortingField.sortingFields = [head, "createdWhen"];
        this.searchReport();
    }

    triggerSearchFromPager(pager: any) {
        this.searchParam.paging.limit = pager.pageSize;
        this.searchParam.paging.pageNo = pager.currentPage;
        if (this.searchParam.facility.name == "All") {
            this.loadContentFacilityAll(this.searchParam.paging.pageNo);
        } else {
            this.search();
        }
    }

    // facility为All 前端分页使用
    private loadContentFacilityAll(currentPage: number) {
        this.orginInquiryReports.data = this.excelByFacilityAll.data.slice((currentPage - 1) * this.searchParam.paging.limit, currentPage * this.searchParam.paging.limit > this.excelByFacilityAll.data.length ? this.excelByFacilityAll.data.length : currentPage * this.searchParam.paging.limit);
        this.setInitGroupReport();
        this.$forceUpdate();
    }

    private initOrderChildItem() {
        this.itemLoading = {};
        this.childrenShow = {};
        this.childrenReport = {};
        this.childrenReportPager = {};
    }

    itemLoading: any = {};
    childrenShow: any = {};
    childrenReport: any = {};
    childrenReportPager: any = {};

    showChildItemTable(orderId: any, facilityName?: any, forcedDisplay?: any) {

        this.initChildrenSearch(orderId);
        if (forcedDisplay) {
            this.childrenShow[orderId] = true;
        }
        if (!this.childrenShow[orderId]) return;
        let param = this.removeFacilityParamAndFillTitleIdsWhenSearch(cloneDeep(this.searchParam));
        this.deleteParams(param);
        param.paging = { pageNo: 1, limit: 10 };
        if (facilityName) {
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "name");
            param.facilityId = facilities[facilityName].id;
            param.facilityName = facilities[facilityName].accessUrl;
            orderId = orderId.replace(facilityName, "");
        }
        param.orderIds = [orderId];
        if (param.itemKeywords) {
            delete param.itemKeywords;
        }
        if (param.keywords) {
            delete param.keywords;
        }
        this.searchItemLevelReportByPaging(param, facilityName);
    }

    showIDLevelAndCartonLevel(itemLevel: any, facilityName?: any) {
        let idLevelKey = 'idLevel-' + itemLevel['orderId'] + itemLevel['itemSpecId'] + itemLevel['unitId'];
        let cartonLevelKey = 'cartonLevel-' + itemLevel['orderId'] + itemLevel['itemSpecId'] + itemLevel['unitId'];
        this.initChildrenSearch(idLevelKey);
        this.initChildrenSearch(cartonLevelKey);
        if (!this.childrenShow[idLevelKey]) return;
        let idParam: any = { paging: { pageNo: 1, limit: 10 }, orderIds: [itemLevel['orderId']], itemSpecId: itemLevel['itemSpecId'], lotNos: itemLevel['lotNo'] ? [itemLevel['lotNo']] : [] };
        let cartonParam: any = { orderIds: [itemLevel['orderId']], itemSpecId: itemLevel['itemSpecId'], lotNos: itemLevel['lotNo'] ? [itemLevel['lotNo']] : [] };
        if (facilityName) {
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "name");
            idParam.facilityId = facilities[facilityName].id;
            idParam.facilityName = facilities[facilityName].accessUrl;
            cartonParam.facilityId = facilities[facilityName].id;
            cartonParam.facilityName = facilities[facilityName].accessUrl;
        }
        this.searchIDLevelReportByPaging(idParam, idLevelKey);
        this.searchCartonLevelReportByPaging(cartonParam, cartonLevelKey);
    }

    private initChildrenSearch(key: any) {
        this.childrenShow[key] = !this.childrenShow[key];
        this.childrenReport[key] = null;
        this.childrenReportPager[key] = null;
        this.$forceUpdate();
    }


    private searchItemLevelReportByPaging(param: any, facilityName?: any) {
        if (!facilityName) { facilityName = ""; }
        let DetailColumns = reportUtil.getDetailColumnList(this.customizitionTableView);
        if (DetailColumns.length > 0) {
            param.headerList = DetailColumns;
        }
        this.itemLoading[(param.orderIds).toString() + facilityName] = true;
        this.$forceUpdate();
        outboundService.searchOutboundInquiryItemLevelReportByPaging(param).subscribe(
            res => {
                this.childrenReport[(param.orderIds).toString() + facilityName] = res.results;
                this.childrenReportPager[(param.orderIds).toString() + facilityName] = { paging: res.paging };
                this.itemLoading[(param.orderIds).toString() + facilityName] = false;
                this.$forceUpdate();
            },
            err => {
                this.itemLoading[(param.orderIds).toString() + facilityName] = false;
                errorHandler.handle(err);
            }
        );
    }

    searchItemLevelReportFromPager(pager: any) {
        let orderId = pager.currentDate['orderId'];
        if (orderId && this.childrenReportPager[orderId]) {
            let param = this.removeFacilityParamAndFillTitleIdsWhenSearch(cloneDeep(this.searchParam));
            this.deleteParams(param);
            param.paging.limit = pager.pageSize;
            param.paging.pageNo = pager.currentPage;
            param.orderIds = [orderId];
            this.searchItemLevelReportByPaging(param);
        }

    }

    private searchIDLevelReportByPaging(param: any, idLevelkey: string) {
        let DetailColumns = reportUtil.getIDLevelColumnList(this.customizitionTableView);
        param.headerList = DetailColumns;
        if (!param.headerList.length) {
            errorHandler.handle('Please Select at least one criteria for each customize column.');
            return;
        }
        this.itemLoading[idLevelkey] = true;
        param.reportCategory = this.searchParam.reportCategory;
        param.customerId = this.searchParam.customerId;
        this.$forceUpdate();
        outboundService.searchOutboundInquiryIdLevelReportByPaging(param).subscribe(
            res => {
                this.childrenReport[idLevelkey] = res.results;
                this.childrenReportPager[idLevelkey] = { paging: res.paging };
                this.itemLoading[idLevelkey] = false;
                this.$forceUpdate();
            },
            err => {
                this.itemLoading[idLevelkey] = false;
                errorHandler.handle(err);
            }
        );
    }

    private searchCartonLevelReportByPaging(param: any, cartonLevelKey: string) {
        let cartonColumns = reportUtil.getCartonLevelColumnList(this.customizitionTableView);
        param.headerList = cartonColumns;
        if (!param.headerList.length) {
            errorHandler.handle('Please Select at least one criteria for each customize column.');
            return;
        }
        this.itemLoading[cartonLevelKey] = true;
        param.reportCategory = this.searchParam.reportCategory;
        param.customerId = this.searchParam.customerId;
        this.$forceUpdate();
        outboundService.searchOutboundInquiryCartonLevelReportByPaging(param).subscribe(
            res => {
                this.childrenReport[cartonLevelKey] = res.results;
                this.childrenReportPager[cartonLevelKey] = { paging: { pageNo: 1, totalCount: res.results.data.length, limit: 10 } };
                this.loadContent(1, cartonLevelKey);
                this.itemLoading[cartonLevelKey] = false;
                this.$forceUpdate();
            },
            err => {
                this.itemLoading[cartonLevelKey] = false;
                errorHandler.handle(err);
            }
        );
    }

    searchIDLevelReportFromPager(pager: any) {
        let orderId = pager.currentDate['orderId'];
        let idLevelKey = 'idLevel-' + pager.currentDate['orderId'] + pager.currentDate['itemSpecId'] + pager.currentDate['unitId'];
        if (orderId && this.childrenReportPager[idLevelKey]) {
            let param = this.removeFacilityParamAndFillTitleIdsWhenSearch(cloneDeep(this.searchParam));
            this.deleteParams(param);
            param.paging.limit = pager.pageSize;
            param.paging.pageNo = pager.currentPage;
            param.itemSpecId = pager.currentDate['itemSpecId'];
            param.lotNos = pager.currentDate['lotNo'] ? [pager.currentDate['lotNo']] : [];
            param.orderIds = [orderId];
            this.searchIDLevelReportByPaging(param, idLevelKey);
        }

    }

    cartonCurrentPageDate: any = {};
    searchCartonLevelReportFromPager(pager: any) {
        let cartonLevelKey = 'cartonLevel-' + pager.currentDate['orderId'] + pager.currentDate['itemSpecId'];
        let pageNo = pager.currentPage;
        this.childrenReportPager[cartonLevelKey].paging.pageNo = pageNo;
        this.childrenReportPager[cartonLevelKey].paging.limit = pager.pageSize;
        this.loadContent(pageNo, cartonLevelKey);
    }

    private loadContent(currentPage: number, cartonKey: string) {
        this.cartonCurrentPageDate[cartonKey] = this.childrenReport[cartonKey].data.slice((currentPage - 1) * this.childrenReportPager[cartonKey].paging.limit,
            currentPage * this.childrenReportPager[cartonKey].paging.limit > this.childrenReport[cartonKey].data.length ? this.childrenReport[cartonKey].data.length : currentPage * this.childrenReportPager[cartonKey].paging.limit);
        this.$forceUpdate();
    }

    getItemLevelKey(inquiry: any) {
        if (!inquiry["facilityName"]) {
            inquiry["facilityName"] = "";
        }
        return inquiry['orderId'] + inquiry["facilityName"];
    }

    getIdLevelKey(itemLevel: any) {
        return 'idLevel-' + itemLevel['orderId'] + itemLevel['itemSpecId'] + itemLevel['unitId'];
    }

    getCartonLevelKey(itemLevel: any) {
        return 'cartonLevel-' + itemLevel['orderId'] + itemLevel['itemSpecId'] + itemLevel['unitId'];
    }

    getLeveLData(key: any) {
        return this.childrenReport[key] ? this.childrenReport[key].data : [];
    }

    getLeveLHead(key: any) {
        return this.childrenReport[key] ? this.childrenReport[key].head : [];
    }

    getToTalCount(orderId: any) {
        return this.childrenReportPager[orderId] ? this.childrenReportPager[orderId].paging.totalCount : null;
    }

    getPageSize(orderId: any) {
        return this.childrenReportPager[orderId] ? this.childrenReportPager[orderId].paging.limit : 10;
    }

    setPageVisibility(orderId: any) {
        if (this.childrenReportPager[orderId] && this.childrenReportPager[orderId].paging.totalCount > 10) {
            return true;
        } else {
            return false;
        }
    }

    getItemLeveLData(orderId: any) {
        let itemLevelData = [];
        if (this.childrenReport[orderId] && this.childrenReport[orderId].data) {
            itemLevelData = forEach(this.childrenReport[orderId].data, function (data) {
                if (!Array.isArray(data['Tracking No'])) {
                    data['Tracking No'] = data['Tracking No'].split(',');
                }
                return data;
            });
        }
        return itemLevelData;
    }

    getItemLeveLHead(orderId: any) {
        return this.childrenReport[orderId] ? this.childrenReport[orderId].head : [];
    }

    mounted() {
        this.init();
    }

    private exportExcel(selectedExcelName: string) {
        let param = this.removeFacilityParamAndFillTitleIdsWhenSearch(cloneDeep(this.searchParam));
        this.deleteParams(param);
        param = this.addOrderIds(param);
        if (selectedExcelName === 'Order Level (.xls)') {
            param.headerList = reportUtil.getNestedColumnList(this.customizitionTableView);
            return outboundService.orderLevelDownLoad(param);
        } else if (selectedExcelName === 'Item Level (.xls)') {
            param.headerList = reportUtil.getDetailColumnList(this.customizitionTableView);
            return outboundService.itemLevelDownLoad(param);
        } else if (selectedExcelName === 'ID Level (.xls)') {
            param.headerList = reportUtil.getIDLevelColumnList(this.customizitionTableView);
            return outboundService.idLevelDownLoad(param);
        } else if (selectedExcelName === 'Carton Level (.xls)') {
            param.headerList = reportUtil.getCartonLevelColumnList(this.customizitionTableView);
            return outboundService.cartonLevelDownLoad(param);
        } else if (selectedExcelName === 'Expanding Level(.xls)') {
            param.headerList = reportUtil.getExcelColumnList(this.customizitionTableView);
            return outboundService.expandingLevelDownLoad(param);
        }
        return (new Promise(() => null));
    }

    isDynTxt(head: string) {
        if (head === 'OrderDynTxtProperty' || head === 'OrderItemLineDynTxtProperty') {
            return true;
        } else {
            return false;
        }
    }

    analysisDynTxt(value: any, head: string) {
        if (head === 'ReceiptDynTxtProperty' || head === 'ReceiptItemLineDynTxtProperty') {
            if (value) {
                return value.split(',');
            }
        }
    }

    isSelectedAll: boolean = false;
    selectedInquirys: Array<any> = [];
    selectAll() {
        this.isSelectedAll = !this.isSelectedAll;
        if (this.isSelectedAll) {
            this.selectedInquirys = this.orginInquiryReports.data;
        } else {
            this.selectedInquirys = [];
        }
    }

    selectSingle(orderInquiry: any) {
        let isContain = find(this.selectedInquirys, { "orderId": orderInquiry.orderId});
        if (!isContain) {
            this.selectedInquirys.push(orderInquiry);
            // let orginDate =  filter(this.orginInquiryReports.data, 'allAssociatedFileId');
            // let selectedDate = filter(this.selectedInquirys, 'allAssociatedFileId');
            if (this.selectedInquirys.length > 0 && this.selectedInquirys.length === this.orginInquiryReports.data.length) {
                this.isSelectedAll = true;
            }
        } else {
           remove(this.selectedInquirys, (select: any) => select.orderId == orderInquiry.orderId);
           this.isSelectedAll = false;
        }
        this.$forceUpdate();
    }

    isChecked(orderInquiry: any) {
        let isContain = find(this.selectedInquirys, { "orderId": orderInquiry.orderId});
        if (!isContain) {
            return false;
        }
        return true;
    }

    exportPdfLoading: boolean = false;
    batchDownloadPdf() {
        // if (this.isSelectedAll) {
        //     this.selectedInquirys = filter(this.orginInquiryReports.data, 'allAssociatedFileId');
        // }
        if (!this.selectedInquirys.length) {
            util.popUpWarningMessage('Please Select at least one valid record.');
            return;
        }
        let selectedInquirys = filter(this.selectedInquirys, 'allAssociatedFileId');
        if (!selectedInquirys.length) {
            errorHandler.handle('No File Found!');
            return;
        }
        if (selectedInquirys.length === 0 ) return;
        let obv: any = [];
        forEach(selectedInquirys, (orderInquiry) => {
            let fileDownloadUrl = util.buildItemDownloadUrl(orderInquiry.allAssociatedFileId);
            obv.push(fileService.getCombinedPdf(fileDownloadUrl, {
                responseType: 'arraybuffer',
                referenceNo: orderInquiry.referenceNo,
                orderId: orderInquiry.orderId,
                headers: { accessUrl: this.getAccessUrl(orderInquiry) }
            }));
        });
        this.exportPdfLoading = true;
        Observable.forkJoin(...obv).subscribe(
        res => {
            forEach(res, (rs: any) => {
                let fileName = rs.config.referenceNo ? rs.config.referenceNo : rs.config.orderId;
                util.exportFile(rs, fileName + '.pdf');
            });
            this.exportPdfLoading = false;
        }, err => {
            this.exportPdfLoading = false;
            errorHandler.handle(err);
        });
    }

    downloadPdf(orderInquiry: any) {
        this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.PDF, true);

        fileService.getCombinedPdf("/wms-app/outbound/download-bol/" + orderInquiry.orderId, { responseType: 'arraybuffer', headers: { accessUrl: this.getAccessUrl(orderInquiry) } }).then((res => {
            let fileName = orderInquiry.referenceNo ? orderInquiry.referenceNo : orderInquiry.orderId;
            util.exportFile(res, fileName + '.pdf');
            this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.PDF, false);
        })).catch(err => {
            errorHandler.handle(err);
            this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.PDF, false);
        });
    }

    downloadPackingListPdf(orderInquiry: any) {
        this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.PACKING_LIST, true);

        let fileDownloadUrl = util.buildPackingListDownloadUrl(orderInquiry.orderId);
        fileService.getCombinedPdf(fileDownloadUrl, { responseType: 'arraybuffer', headers: {accessUrl: this.getAccessUrl(orderInquiry)} }).then((res => {
            let fileName = orderInquiry.orderId;
            util.exportFile(res, fileName + '.pdf');
            this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.PACKING_LIST, false);
        })).catch(err => {
            errorHandler.handle(err);
            this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.PACKING_LIST, false);
        });
    }

    downloadGenericPackingListPdf(orderInquiry: any) {
        if (isEmpty(orderInquiry.orderId)) {
            util.popUpWarningMessage('');
            return;
        }
        this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.G_PACKING_LIST, true);
        outboundService.getGenericPackingListPdf(orderInquiry.orderId, { accessUrl: this.getAccessUrl(orderInquiry) }).pipe(
            finalize(() => {
                this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.G_PACKING_LIST, false);
            })
        ).subscribe(
            res => {
                let fileId = res.fileId || "";
                let fileDownloadUrl = util.buildItemDownloadUrl(fileId);
                fileService.getCombinedPdf(fileDownloadUrl, { responseType: 'arraybuffer' }).then((res => {
                    let fileName = orderInquiry.orderId + " _GenericPackingList";
                    util.exportFile(res, fileName + '.pdf');
                })).catch(err => {
                    errorHandler.handle(err);
                });
            },
            err => {
                errorHandler.handle(err);
            }
        );
    }

    downloadMBOL(orderInquiry: any) {
        if (isEmpty(orderInquiry['loadId'])) {
            util.popUpWarningMessage('');
            return;
        }
        this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.M_BOL, true);
        outboundService.getGenericBolPdf(orderInquiry['loadId'], { accessUrl: this.getAccessUrl(orderInquiry) }).pipe(
            finalize(() => {
                this.updatePdfDownloadStatus(orderInquiry.orderId, PdfFileType.M_BOL, false);
            })
        ).subscribe(
            res => {
                let fileIds = res.fileIds || [];
                let fileId = fileIds[0];
                let fileDownloadUrl = util.buildItemDownloadUrl(fileId);
                fileService.getCombinedPdf(fileDownloadUrl, { responseType: 'arraybuffer' }).then((res => {
                    let fileName = orderInquiry["mBol"] ? orderInquiry["mBol"] : (orderInquiry["bolNo"] ? orderInquiry["bolNo"] : orderInquiry["Load ID"]);
                    util.exportFile(res, fileName + '.pdf');
                })).catch(err => {
                    errorHandler.handle(err);
                });
            },
            err => {
                errorHandler.handle(err);
            }
        );
    }

    updatePdfDownloadStatus(key: string, type: string, isLoading: boolean) {
        let target = this.pdfsDownloadStatus.get(key);
        if (!target) {
            target = new Map();
            this.pdfsDownloadStatus.set(key, target);
        }
        target.set(type, isLoading);

        // assign new value so the data in view can be auto updated
        const pdfsDownloadStatus = new Map();
        this.pdfsDownloadStatus.forEach((value, key) => pdfsDownloadStatus.set(key, value));
        this.pdfsDownloadStatus = pdfsDownloadStatus;
    }

    getPdfDownloadStatus(key: string, type: string): boolean {
        return !!this.pdfsDownloadStatus.get(key)?.get(type);
    }

    getAccessUrl(orderInquiry: any) {
        let accessUrl = "";
        if (this.searchParam.facility.name == "All" && orderInquiry.facilityId) {
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "id");
            accessUrl = facilities[orderInquiry.facilityId].accessUrl;
        }
        return accessUrl;
    }

    private deleteParams(searchParam: any) {
        delete searchParam.itemSpecId;
        if (searchParam.itemSpecIds && searchParam.itemSpecIds.length === 0 ) {
            delete searchParam.itemSpecIds;
        }
        if (searchParam.statuses && searchParam.statuses.length === 0 ) {
            delete searchParam.statuses;
        }
        if (searchParam.loadStatuses && searchParam.loadStatuses.length === 0 ) {
            delete searchParam.loadStatuses;
        }
    }

    downLoadIdLevelItemLevel(itemLevel: any, facilityName?: any) {
        let idLevelKey = this.getIdLevelKey(itemLevel);
        let param: any = { paging: { pageNo: 1, limit: 10 }, orderIds: [itemLevel['orderId']], itemSpecId: itemLevel['itemSpecId'], lotNos: itemLevel['lotNo'] ? [itemLevel['lotNo']] : [] };
        param.headerList = reportUtil.getIDLevelColumnList(this.customizitionTableView);
        param.reportCategory = this.searchParam.reportCategory;
        param.customerId = this.searchParam.customerId;
        this.$set(this.itemExcelLoadingObj, idLevelKey, true);
        if (facilityName) {
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "name");
            param.facilityId = facilities[facilityName].id;
            param.facilityName = facilities[facilityName].accessUrl;
        }
        outboundService.idLevelDownLoad(param).then((res => {
            this.$set(this.itemExcelLoadingObj, idLevelKey, false);
            util.exportFile(res, `Outbound-ID-Level-Detail-${itemLevel['orderId']}.xlsx`);
        })).catch((err: any) => {
            this.$set(this.itemExcelLoadingObj, idLevelKey, false);
            errorHandler.handle(err);
        });
    }

    downLoadCartonLevelItemLevel(itemLevel: any, facilityName?: any) {
        let cartonLevelKey = this.getCartonLevelKey(itemLevel);
        let param: any = { orderIds: [itemLevel['orderId']], itemSpecId: itemLevel['itemSpecId'], lotNos: itemLevel['lotNo'] ? [itemLevel['lotNo']] : [] };
        param.headerList = reportUtil.getCartonLevelColumnList(this.customizitionTableView);
        param.reportCategory = this.searchParam.reportCategory;
        param.customerId = this.searchParam.customerId;
        this.$set(this.itemExcelLoadingObj, cartonLevelKey, true);
        if (facilityName) {
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "name");
            param.facilityId = facilities[facilityName].id;
            param.facilityName = facilities[facilityName].accessUrl;
        }
        outboundService.cartonLevelDownLoad(param).then((res => {
            this.$set(this.itemExcelLoadingObj, cartonLevelKey, false);
            util.exportFile(res, `Outbound-Carton-Level-Detail-${itemLevel['orderId']}.xlsx`);
        })).catch((err: any) => {
            this.$set(this.itemExcelLoadingObj, cartonLevelKey, false);
            errorHandler.handle(err);
        });
    }

    editOrder(orderId: any) {
        this.$router.replace({name: 'OrderEntry', query: {orderId: orderId}});
    }


    attachmentUpload(orderInquiry: any) {
        this.$validator.errors.clear();
        Object.assign(this.popUpConfig, {
            isShow: true,
            height: 500,
            title: `Attachment Upload`,
            isSubmit: false,
            modal: 'Attachment'
        });
        this.attachmentOrder = orderInquiry;
        if (this.attachmentOrder['Facility']) {
            let facilities = this.getfacilitiesBySelectedCustomer();
            facilities = keyBy(facilities, "name");
            this.attachmentOrder['accessUrl'] = facilities[this.attachmentOrder['Facility']].accessUrl;
        }
        if (this.getAccessUrl(orderInquiry)) {
            this.attachmentOrder['accessUrl'] = this.getAccessUrl(orderInquiry);
        }
    }

    cancel(item: any) {
        this.orderId = item.orderId;
        this.popups({
            title: 'Cancel Confirm',
            content: `Would you like to cancel this order?`,
            cancel: 'No',
            confirm: 'Yes'
        }).then(
            (res: any) => {
                outboundService.cancelOrder( {orderId: this.orderId} ).subscribe(
                    res => {
                        this.loading = false;
                        this.searchReport();
                    },
                    err => {
                        this.loading = false;
                        errorHandler.handle(err);
                    }
                );
            }
        );
    }
}
